// De donde se llego al visor de una guia, para poder regresar al mismo lugar.
//
// El boton "Volver" del visor mandaba SIEMPRE a /guides2. Quien entraba por la
// liga oculta de contratacion (/guides2/contratar), abria su guia y volvia,
// aterrizaba en el catalogo general: perdia la vista de venta y, con ella, la
// liga que le acaban de dar en el webinar — que es justo lo que VIVA-1214 pide
// no perder.
//
// El origen viaja en la URL (`?from=`) y no en el estado del router, por el
// mismo motivo que en `eventDetailOrigins`: asi sobrevive a una recarga de la
// pagina y a un enlace compartido.
//
// El valor se valida SIEMPRE contra esta lista: uno desconocido o manipulado cae
// al catalogo en vez de navegar a donde diga la URL.

import {
  buildGuides2ViewPath,
  guides2CheckoutPath,
  guides2Path,
  userMyGuidesPath,
} from "./routes";

export const GUIDE_VIEWER_ORIGIN = {
  // Catalogo de guias (/guides2)
  CATALOG: "guides2",
  // Liga oculta de contratacion (/guides2/contratar)
  CHECKOUT: "contratar",
  // Pestana "Mis guias" dentro del perfil (/user/my-guides). Mismo motivo que
  // PROFILE_EVENTS en `eventDetailOrigins`: quien abre una guia desde su perfil
  // debe volver a su perfil, no al catalogo general.
  PROFILE_GUIDES: "profile-guides",
};

const ORIGIN_ROUTES = {
  [GUIDE_VIEWER_ORIGIN.CATALOG]: guides2Path,
  [GUIDE_VIEWER_ORIGIN.CHECKOUT]: guides2CheckoutPath,
  [GUIDE_VIEWER_ORIGIN.PROFILE_GUIDES]: userMyGuidesPath,
};

export const GUIDE_VIEWER_ORIGIN_PARAM = "from";

// Ruta del visor con el origen anexado. Sin origen la URL queda igual que antes,
// asi que el visor sigue funcionando para quien llegue por un enlace directo.
export const buildGuide2ViewerPath = (guideId, variantTypeCode, origin) => {
  const base = buildGuides2ViewPath(guideId, variantTypeCode);
  if (!origin || !ORIGIN_ROUTES[origin]) return base;

  const params = new URLSearchParams({ [GUIDE_VIEWER_ORIGIN_PARAM]: origin });
  return `${base}?${params.toString()}`;
};

// A donde debe regresar el boton de volver. Acepta la cadena de busqueda
// completa (`location.search`) y devuelve siempre una ruta conocida.
export const resolveGuide2ViewerBackPath = (search) => {
  try {
    const origin = new URLSearchParams(search || "").get(
      GUIDE_VIEWER_ORIGIN_PARAM
    );
    return ORIGIN_ROUTES[origin] || guides2Path;
  } catch (error) {
    console.error("Error al resolver el origen del visor de guías:", error);
    return guides2Path;
  }
};
